"use client";

import React from "react";
import { Loader2 } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
function KontaktForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="235600" className="p-8 bg-card border border-border rounded-lg text-center h-full flex flex-col items-center justify-center min-h-[320px]">
                <p className="text-foreground font-default text-lg font-medium mb-6">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="border-border text-foreground hover:bg-accent hover:text-accent-foreground font-default">
                    Enviar nova mensagem
                </Button>
            </div>;
  }
  const inputClasses = "flex w-full rounded-md border border-border bg-background px-3 py-2.5 text-sm text-foreground shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 font-default";
  return <Form onSubmit={handleSubmit}>
            <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <FormField control={control} name="name" rules={{
          required: "Nome é obrigatório"
        }} render={({
          field
        }) => <FormItem className="space-y-1.5">
                                <FormLabel className="text-muted-foreground text-xs font-medium font-default uppercase tracking-wider">Nome Completo *</FormLabel>
                                <FormControl>
                                    <input className={inputClasses} placeholder="Seu nome" {...field} />
                                </FormControl>
                                <FormMessage className="text-destructive text-[10px] font-default" />
                            </FormItem>} />
                    <FormField control={control} name="email" rules={{
          required: "E-mail é obrigatório",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "E-mail inválido"
          }
        }} render={({
          field
        }) => <FormItem className="space-y-1.5">
                                <FormLabel className="text-muted-foreground text-xs font-medium font-default uppercase tracking-wider">E-mail Corporativo *</FormLabel>
                                <FormControl>
                                    <input type="email" className={inputClasses} placeholder="email@empresa.com" {...field} />
                                </FormControl>
                                <FormMessage className="text-destructive text-[10px] font-default" />
                            </FormItem>} />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <FormField control={control} name="company" render={({
          field
        }) => <FormItem className="space-y-1.5">
                                <FormLabel className="text-muted-foreground text-xs font-medium font-default uppercase tracking-wider">Empresa</FormLabel>
                                <FormControl>
                                    <input className={inputClasses} placeholder="Nome da sua empresa" {...field} />
                                </FormControl>
                                <FormMessage className="text-destructive text-[10px] font-default" />
                            </FormItem>} />
                    <FormField control={control} name="phone" rules={{
          pattern: {
            value: /^[0-9+\-\s()]*$/,
            message: "Formato inválido"
          }
        }} render={({
          field
        }) => <FormItem className="space-y-1.5">
                                <FormLabel className="text-muted-foreground text-xs font-medium font-default uppercase tracking-wider">Telefone</FormLabel>
                                <FormControl>
                                    <input type="tel" className={inputClasses} placeholder="(00) 00000-0000" {...field} />
                                </FormControl>
                                <FormMessage className="text-destructive text-[10px] font-default" />
                            </FormItem>} />
                </div>

                <FormField control={control} name="message" render={({
        field
      }) => <FormItem className="space-y-1.5">
                            <FormLabel className="text-muted-foreground text-xs font-medium font-default uppercase tracking-wider">Mensagem</FormLabel>
                            <FormControl>
                                <textarea className={`${inputClasses} min-h-[100px] resize-y`} placeholder="Como podemos ajudar na sua operação?" {...field} />
                            </FormControl>
                            <FormMessage className="text-destructive text-[10px] font-default" />
                        </FormItem>} />

                {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
                        <p className="text-destructive text-sm font-default">{submitError}</p>
                    </div>}

                <Button type="submit" disabled={isSubmitting} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg border-0 h-12 text-base font-semibold mt-4 transition-all duration-300 font-default">
                    {isSubmitting ? <>
                            <Loader2 className="animate-spin mr-2 size-5" />
                            Enviando...
                        </> : 'Solicitar Demonstração'}
                </Button>
            </div>
        </Form>;
}
export default function KontaktCta() {
  return <section id="contato" className="bg-background text-foreground py-32 px-4 md:px-8 bg-[radial-gradient(circle_at_center,_var(--accent)_0%,_var(--background)_100%)]">
            <div className="max-w-6xl mx-auto bg-card rounded-lg p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row gap-12 lg:gap-16 items-center shadow-2xl border border-border">
                
                <div className="flex-1 text-left w-full">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 text-foreground leading-tight">
                        Pronto para Transformar sua Operação?
                    </h2>
                    <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed max-w-xl">
                        Integre inteligência aérea e automação de dados ao seu fluxo de trabalho. Nossa equipe de especialistas está pronta para desenhar a solução ideal para seus desafios logísticos e técnicos.
                    </p>
                </div>

                <Separator orientation="vertical" className="hidden lg:block h-auto self-stretch bg-border w-[1px]" />
                <Separator orientation="horizontal" className="lg:hidden w-full bg-border h-[1px]" />

                <div className="flex-1 w-full max-w-xl lg:max-w-none">
                    <FormProvider formKey="contact_form_home2" formId="contact_form_home2" sectionName="chamada-à-ação" defaultValues={{
          name: "",
          email: "",
          company: "",
          phone: "",
          message: ""
        }} validationRules={{
          name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            pattern: "phone"
          }
        }} submitText="Solicitar Demonstração" successMessage="Recebemos seu contato! Nossa equipe retornará em breve.">
                        <KontaktForm />
                    </FormProvider>
                </div>

            </div>
        </section>;
}